module.exports = __webpack_public_path__ + "img/ewm_gzh.337a220b.png";